import { loader } from "graphql.macro";
import { executeGraphqlQuery } from "../../graphql/api";

const getClaims = loader(
    "../../graphql/queries/searchClaims.graphql"
);

export default async function claimSearch(searchQuery: any) {
    return executeGraphqlQuery(getClaims,searchQuery);
}

